import React from 'react';
import PropTypes from 'prop-types';

const SeasonFilter = ({ seasons, selectedSeason, onSeasonChange }) => {
  const handleChange = (e) => {
    onSeasonChange(e.target.value);
  };

  return (
    <div className="d-flex align-items-center">
      <label htmlFor="season-filter" className="form-label mb-0 me-2 fw-semibold text-nowrap">
        <i className="fa fa-calendar me-1" />
        Season
      </label>
      <select
        id="season-filter"
        className="form-select form-select-sm"
        value={selectedSeason}
        onChange={handleChange}
        style={{ maxWidth: '160px' }}
      >
        {seasons.map((season) => (
          <option key={season} value={season}>
            {season}
          </option>
        ))}
      </select>
    </div>
  );
};

SeasonFilter.propTypes = {
  seasons: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedSeason: PropTypes.string.isRequired,
  onSeasonChange: PropTypes.func.isRequired,
};

export default SeasonFilter;
